import log, { METRIC_NAME } from "../../logging";
import { useQueryClient } from "@tanstack/react-query";
import { sendGetCookieSynchronizationConfigurationCommand } from "../../utils/ermineSsrClientUtil";
import { UNKNOWN_STATUS_CODE } from "../../constants/common";
import { getFormattedSdkErrorMessage } from "../../utils/errorUtils";

/**
 * TODO https://issues.amazon.com/issues/LOWA-30289
 * Currently using `fetchQuery` for conditional execution in App component with if statements.
 * Unlike useQuery, this requires manual triggering and doesn't auto-execute on dependency changes or render.
 * Will use useQuery when App component is refactored.
 */
export const useGetCookieSyncConfig = () => {
    const queryClient = useQueryClient();

    return async (portalArn: string) => {
        return queryClient.fetchQuery({
            queryKey: ["getCookieSyncConfig", portalArn],
            queryFn: async () => {
                try {
                    const data = await sendGetCookieSynchronizationConfigurationCommand(
                        {
                            portalArn,
                        }
                    );

                    log.publishHttpStatusMetric(
                        METRIC_NAME.OIDC_GET_COOKIE_SYNC_CONFIG,
                        200
                    );
                    return data;
                } catch (err) {
                    await log.error(
                        err
                            ? getFormattedSdkErrorMessage(
                                  err,
                                  "OidcCookieSyncConfigFetcher"
                              )
                            : "Failed to get cookie sync configuration"
                    );
                    log.publishHttpStatusMetric(
                        METRIC_NAME.OIDC_GET_COOKIE_SYNC_CONFIG,
                        err?.$metadata.httpStatusCode ?? UNKNOWN_STATUS_CODE
                    );
                    throw err;
                }
            },
            staleTime: 0,
            cacheTime: 0,
            retry: false,
        });
    };
};
